import React, { useContext } from "react"
import { CoolButton } from "../CoolButton.jsx"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"
import { useTranslation } from "react-i18next"

export const KopyProtectUpgradeCards = ({ onUpgradeClick }) => {
	const { state } = useContext(GlobalStateContext)
	const { t } = useTranslation()

	const featuresAdvertised = [
		t(
			"protect.upgrade.protect_your_products_and_collections_from_getting_copied_by_kopy",
		),
		t(
			"protect.upgrade.block_the_usage_of_any_spy_extensions_on_the_browsers",
		),
		t(
			"protect.upgrade.detects_and_kicks_any_user_from_your_website_that_uses_any_spy_extension",
		),
		t("protect.upgrade.disables_inspect_element_browser_dev_tools_f12"),
		t("protect.upgrade.block_users_from_different_countries"),
		t(
			"protect.upgrade.redirect_customers_based_on_their_country_or_ip_address",
		),
		t(
			"protect.upgrade.blocks_keyboard_shortcuts_that_copy_content_such_as_ctrl_s_ctrl_p_ctrl_a_and_ctrl_u",
		),
		t("protect.upgrade.prevents_your_images_from_being_copied"),
		t("protect.upgrade.prevents_text_from_being_selected_and_copied"),
	]

	const xIcon = (
		<svg
			style={{ color: "red", minWidth: "1.3rem" }}
			width="1.3rem"
			height="1.3rem"
			viewBox="0 0 15 15"
		>
			<path
				fill="currentColor"
				d="M3.64 2.27L7.5 6.13l3.84-3.84A.92.92 0 0 1 12 2a1 1 0 0 1 1 1a.9.9 0 0 1-.27.66L8.84 7.5l3.89 3.89A.9.9 0 0 1 13 12a1 1 0 0 1-1 1a.92.92 0 0 1-.69-.27L7.5 8.87l-3.85 3.85A.92.92 0 0 1 3 13a1 1 0 0 1-1-1a.9.9 0 0 1 .27-.66L6.16 7.5L2.27 3.61A.9.9 0 0 1 2 3a1 1 0 0 1 1-1c.24.003.47.1.64.27"
			></path>
		</svg>
	)
	const checkmarkIcon = (
		<svg
			style={{ color: "green", minWidth: "1.3rem" }}
			width="1.3rem"
			height="1.3rem"
			viewBox="0 0 512 512"
		>
			<path
				d="M448 71.9c-17.3-13.4-41.5-9.3-54.1 9.1L214 344.2l-99.1-107.3c-14.6-16.6-39.1-17.4-54.7-1.8-15.6 15.5-16.4 41.6-1.7 58.1 0 0 120.4 133.6 137.7 147 17.3 13.4 41.5 9.3 54.1-9.1l206.3-301.7c12.6-18.5 8.7-44.2-8.6-57.5z"
				fill="currentColor"
			></path>
		</svg>
	)

	return (
		<div style={{ display: "flex", justifyContent: "center" }}>
			<div
				style={{
					display: "flex",
					gap: "1rem",
					justifyContent: "center",
					alignItems: "start",
					flexWrap: "wrap",
				}}
			>
				<div
					className="border shadow"
					style={{
						background: "#fff",
						color: "#333",
						borderRadius: "1.5rem",
						padding: "1rem 1.5rem",
						width: "25rem",
					}}
				>
					<p
						style={{
							fontSize: "2rem",
							fontWeight: "800",
							marginBottom: "1rem",
						}}
					>
						{t("protect.upgrade.current_plan")}
					</p>
					<div style={{ marginBottom: "2rem" }}>
						<div
							style={{
								display: "flex",
								gap: "0.5rem",
								alignItems: "start",
								marginBottom: "1rem",
							}}
						>
							{checkmarkIcon}
							<div style={{ fontSize: "0.9rem" }}>
								{t(
									"protect.upgrade.copy_any_competitors_products_and_collections_on_shopify_amazon_aliexpress_etsy_and_cjdropshipping",
								)}
							</div>
						</div>
						<div
							style={{
								display: "flex",
								gap: "0.5rem",
								alignItems: "start",
							}}
						>
							{xIcon}
							<div style={{ fontSize: "0.9rem" }}>
								{t(
									"protect.upgrade.anybody_can_copy_your_store_and_products",
								)}
							</div>
						</div>
					</div>
				</div>

				<div
					className="border shadow"
					style={{
						background: "#333",
						color: "#fff",
						borderRadius: "1.5rem",
						padding: "1rem 1.5rem",
						width: "25rem",
					}}
				>
					<div
						style={{
							display: "flex",
							gap: "0.5rem",
							alignItems: "center",
							marginBottom: "1rem",
						}}
					>
						<svg
							style={{
								height: "2rem",
								width: "2rem",
								color: "#fff",
							}}
							viewBox="0 0 512 512"
						>
							<path
								fill="currentColor"
								d="M256 0c4.6 0 9.2 1 13.4 2.9l188.3 79.9c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0m0 66.8v378C394 378 431.1 230.1 432 141.4z"
							></path>
						</svg>
						<p style={{ fontSize: "2rem", fontWeight: "800" }}>
							Kopy Protect
						</p>
					</div>
					<div style={{ marginBottom: "2rem" }}>
						{featuresAdvertised.map((feature, index) => {
							return (
								<div
									key={index}
									style={{
										display: "flex",
										gap: "0.5rem",
										alignItems: "start",
										marginBottom: "0.5rem",
									}}
								>
									{checkmarkIcon}
									<div style={{ fontSize: "0.9rem" }}>
										{feature}
									</div>
								</div>
							)
						})}
					</div>

					<CoolButton onClick={onUpgradeClick}>
						<span style={{ color: "#222", fontWeight: "700" }}>
							{state.hasTrialedKopyProtectBefore
								? t("protect.upgrade.upgrade_now")
								: t("protect.upgrade.start_3_day_free_trial")}
						</span>
					</CoolButton>
				</div>
			</div>
		</div>
	)
}
